module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box text-center"
  }, [(_vm.categoryList.length === 1 && !_vm.productList.length) ? _c('div', {
    staticClass: "box-body"
  }, [_vm._v("\n    無商品，請新增\n  ")]) : _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-xs-12 y-middle"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-danger m-y-10 inline-block pull-right",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delModal"
    }
  }, [_vm._v("\n          刪除\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-black m-y-10 inline-block m-r-10 pull-right",
    on: {
      "click": _vm.gotoCrProducts
    }
  }, [_vm._v("\n          新增\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-black m-y-10 inline-block m-r-10 pull-right",
    attrs: {
      "data-toggle": "modal"
    },
    on: {
      "click": function($event) {
        _vm.show.easy = !_vm.show.easy
      }
    }
  }, [(!_vm.show.easy) ? _c('span', [_vm._v("簡易")]) : _c('span', [_vm._v("進階")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary m-y-10 pull-right m-r-10 ",
    attrs: {
      "data-toggle": "modal"
    },
    on: {
      "click": _vm.copyProduct
    }
  }, [_vm._v("複製商品")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-2 text-left"
  }, [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.select.category),
      expression: "select.category"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "46px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.select, "category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.categoryList), function(category) {
    return _c('option', {
      key: category.item_id,
      domProps: {
        "value": category.item_id
      }
    }, [_vm._v("\n              " + _vm._s(category.name) + _vm._s(category.remark ? (" (" + (category.remark) + ")") : '') + "\n            ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "bg-light-gray m-t-10 select-element-block"
  }, _vm._l((_vm.productList), function(product, index) {
    return _c('div', {
      staticClass: "select-element",
      class: {
        'active': _vm.curId === product.item_id
      },
      attrs: {
        "disabled": _vm.isLoad || _vm.curId === product.item_id
      },
      on: {
        "click": function($event) {
          return _vm.clickProduct(product, index)
        }
      }
    }, [_c('span', {
      staticClass: "text-w-600"
    }, [_vm._v(_vm._s(product.name))]), _vm._v(" "), _c('small', {
      staticStyle: {
        "opacity": ".7"
      }
    }, [_vm._v("  " + _vm._s(product.remark))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-10"
  }, [_c('ul', {
    staticClass: "col-xs-12 nav nav-tabs m-l-10 m-r-10"
  }, [_c('li', {
    class: {
      'active': _vm.tab == 1
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.tab = 1
      }
    }
  }, [_c('a', [_vm._v("明細")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.tab == 2
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.tab = 2
      }
    }
  }, [_c('a', [_vm._v("組合 "), (!_vm.combinationList.length) ? _c('span', {
    staticClass: "text-danger"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()])])]), _vm._v(" "), (!_vm.productList.length) ? _c('div', {
    staticClass: "box-body col-xs-12"
  }, [_c('p', {
    staticClass: "text-center text-danger col-xs-12",
    staticStyle: {
      "margin": "50px 0px"
    }
  }, [_vm._v("此分類無任何商品")])]) : _c('div', {
    staticClass: "box-body form menu-form col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-6 text-left"
  }, [(_vm.tab === 2) ? _c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.combinationList), function(combine) {
    return _c('button', {
      staticClass: "btn btn-default m-y-10 btn-combine",
      class: {
        'active': _vm.curCId === combine.combine_id
      },
      on: {
        "click": function($event) {
          return _vm.clickCombine(combine.combine_id)
        }
      }
    }, [_vm._v(_vm._s(combine.name))])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 text-left"
  }, [(_vm.tab === 2) ? _c('div', {
    staticClass: "col-xs-12 text-right"
  }, [(_vm.curCId) ? _c('button', {
    staticClass: "btn btn-primary m-y-10 m-r-10 ",
    attrs: {
      "data-target": "#choseProdModal",
      "data-toggle": "modal"
    }
  }, [_vm._v("複製組合")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-black m-y-10 m-r-10 ",
    on: {
      "click": function($event) {
        return _vm.newCombine()
      }
    }
  }, [_vm._v("新增組合")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger m-y-10 inline-block pull-right",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delCombineModal"
    }
  }, [_vm._v("\n                  刪除組合\n                ")])]) : _vm._e()])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tab === 1),
      expression: "tab === 1"
    }],
    staticClass: "col-xs-12 col-md-6 p-r-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productInfo.name),
      expression: "productInfo.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.productInfo.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.productInfo, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productInfo.sort),
      expression: "productInfo.sort"
    }],
    ref: "sort",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.productInfo.sort)
    },
    on: {
      "keyup": function($event) {
        return _vm.veritySort()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.productInfo, "sort", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productInfo.price),
      expression: "productInfo.price"
    }],
    ref: "price",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.productInfo.price)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityPrice()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.productInfo, "price", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productInfo.remark),
      expression: "productInfo.remark"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.productInfo.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.productInfo, "remark", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productInfo.sub_type),
      expression: "productInfo.sub_type"
    }],
    staticClass: "form-control h-34",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.productInfo, "sub_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("一般商品")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 101
    }
  }, [_vm._v("塑膠袋")])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show.easy && _vm.tab === 1),
      expression: "!show.easy && tab === 1"
    }],
    staticClass: "col-xs-12 col-md-6 p-l-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productInfo.min_limit),
      expression: "productInfo.min_limit"
    }],
    ref: "minLimit",
    staticClass: "c-auto form-control",
    staticStyle: {
      "width": "calc(50% - 10px)"
    },
    attrs: {
      "placeholder": "0為無上限",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.productInfo.min_limit)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityMinLimit()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.productInfo, "min_limit", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pull-left",
    staticStyle: {
      "line-height": "38px",
      "width": "20px"
    }
  }, [_vm._v("~")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productInfo.max_limit),
      expression: "productInfo.max_limit"
    }],
    ref: "maxLimit",
    staticClass: "c-auto form-control",
    staticStyle: {
      "width": "calc(50% - 10px)"
    },
    attrs: {
      "placeholder": "0為無上限",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.productInfo.max_limit)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityMaxLimit()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.productInfo, "max_limit", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productInfo.price_type),
      expression: "productInfo.price_type"
    }],
    staticClass: "form-control h-34",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.productInfo, "price_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("免稅價格")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("含稅價格")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(8), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productInfo.calorie),
      expression: "productInfo.calorie"
    }],
    ref: "calorie",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.productInfo.calorie)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityCalorie()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.productInfo, "calorie", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(9), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productInfo.description),
      expression: "productInfo.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.productInfo.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.productInfo, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("商品料號")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productInfo.vendor_custom_id),
      expression: "productInfo.vendor_custom_id"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.productInfo.vendor_custom_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.productInfo, "vendor_custom_id", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tab === 2),
      expression: "tab === 2"
    }],
    staticClass: "col-xs-12 col-md-6 p-r-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(10), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.combineDetail.name),
      expression: "combineDetail.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.combineDetail.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.combineDetail, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "radio text-left h-38",
    staticStyle: {
      "border-left": "1px solid #d2d6de"
    }
  }, [_c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.combineDetail.is_common),
      expression: "combineDetail.is_common"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "commonRadio"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.combineDetail.is_common, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.combineDetail, "is_common", 1)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("是")])]), _vm._v(" "), _c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.combineDetail.is_common),
      expression: "combineDetail.is_common"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "commonRadio"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.combineDetail.is_common, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.combineDetail, "is_common", 0)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("否")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(12), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.combineDetail.remark),
      expression: "combineDetail.remark"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.combineDetail.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.combineDetail, "remark", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show.easy && _vm.tab === 2),
      expression: "!show.easy && tab === 2"
    }],
    staticClass: "col-xs-12 col-md-6 p-l-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(14), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.combineDetail.product.edge_price),
      expression: "combineDetail.product.edge_price"
    }],
    ref: "priceProduct",
    staticClass: "form-control",
    attrs: {
      "placeholder": "選取組合內的選項皆為此價格",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.combineDetail.product.edge_price)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityPriceProduct()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.combineDetail.product, "edge_price", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(15), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.combineDetail.price),
      expression: "combineDetail.price"
    }],
    ref: "priceCombine",
    staticClass: "form-control",
    attrs: {
      "placeholder": "選取組合內的選項皆為此價格",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.combineDetail.price)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityPriceCombine()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.combineDetail, "price", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.combineDetail.price_type),
      expression: "combineDetail.price_type"
    }],
    staticClass: "form-control h-34",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.combineDetail, "price_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("免稅價格")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("含稅價格")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkAdjustActive),
      expression: "checkAdjustActive"
    }],
    staticClass: "input-group"
  }, [_vm._m(17), _vm._v(" "), _c('button', {
    staticClass: "form-control btn btn-default",
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "data-toggle": "modal",
      "data-target": "#choseOptionModal"
    }
  }, [_vm._v("選擇特定配料")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkAdjustActive),
      expression: "checkAdjustActive"
    }],
    staticClass: "input-group"
  }, [_vm._m(18), _vm._v(" "), _c('button', {
    staticClass: "form-control btn btn-default",
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "data-toggle": "modal",
      "data-target": "#choseMoneyModal"
    }
  }, [_vm._v("變更配料金額")])]), _vm._v(" "), _c('br')])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.gotoOut
    }
  }, [_vm._v("\n      返回\n    ")]), _vm._v(" "), (_vm.categoryList.length === 1 && !_vm.productList.length) ? _c('button', {
    staticClass: "btn btn-default btn-black",
    on: {
      "click": _vm.gotoCrProducts
    }
  }, [_vm._v("\n      新增\n    ")]) : (_vm.productList.length) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.clickSave
    }
  }, [_vm._v("\n      儲存\n    ")]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('c-modal', {
    attrs: {
      "hideCancel": true,
      "elementList": _vm.allProductList,
      "option": _vm.choseProdOption,
      "curId": _vm.curId
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('c-modal', {
    attrs: {
      "hideCancel": true,
      "elementList": _vm.adjustList,
      "option": _vm.choseOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('c-o-modal', {
    attrs: {
      "hideCancel": true,
      "adjustList": _vm.adjustList,
      "option": _vm.optionOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('c-m-modal', {
    attrs: {
      "hideCancel": true,
      "adjustList": _vm.adjustList,
      "option": _vm.moneyOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.delProductOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.delCombineOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline-block pull-left"
  }, [_c('h4', {
    staticClass: "pull-left"
  }, [_vm._v("\n          商品\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("產品名稱")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("排"), _c('div', {
    staticClass: "inline-block w-35"
  }), _vm._v("序")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("價"), _c('div', {
    staticClass: "inline-block w-35"
  }), _vm._v("格")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('div', {
    staticClass: "inline-block w-22"
  }), _vm._v("備"), _c('div', {
    staticClass: "inline-block w-35"
  }), _vm._v("註")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("商品類型")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("選購數量")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("價格類型")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('div', {
    staticClass: "inline-block w-22"
  }), _vm._v("熱"), _c('div', {
    staticClass: "inline-block w-35"
  }), _vm._v("量")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('div', {
    staticClass: "inline-block w-22"
  }), _vm._v("描"), _c('div', {
    staticClass: "inline-block w-35"
  }), _vm._v("述")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("組合名稱")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("常見價格")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('div', {
    staticClass: "inline-block w-22"
  }), _vm._v("備"), _c('div', {
    staticClass: "inline-block w-35"
  }), _vm._v("註")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("配料群組")]), _vm._v(" "), _c('button', {
    staticClass: "form-control btn btn-default",
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "data-toggle": "modal",
      "data-target": "#choseModal"
    }
  }, [_vm._v("選擇配料群組")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('div', {
    staticClass: "inline-block w-22"
  }), _vm._v("商品價格")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('div', {
    staticClass: "inline-block w-22"
  }), _vm._v("組合價格")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('div', {
    staticClass: "inline-block w-22"
  }), _vm._v("價格類型")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("配料單選")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("組合內金額")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-480f46e8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Menu/Temp/CrProductTemp.vue
// module id = 2402
// module chunks = 1